import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONTRACHEQUE } from '../../../../app.constants';
import { ContraChequeAposentadosModel } from '../../../shared/models/contra-cheque-aposentados.model';
import { ContraChequeFuncCentrusModel } from '../../../shared/models/contra-cheque-func-centrus.model';

@Injectable()
export class ContrachequeService {


    constructor(private httpClient: HttpClient) { }



    getEspelhoFolhaPagtoWebFunc(centrus: number, mes: number, ano: number) {
        return this.httpClient
          .get<ContraChequeFuncCentrusModel>(`${CONTRACHEQUE}/func/${centrus}/${mes}/${ano}`)
          .toPromise();
      }

      getEspelhoFolhaPagtoWebAposentados(centrus: number, mes: number, ano: number) {
        return this.httpClient
          .get<ContraChequeAposentadosModel>(`${CONTRACHEQUE}/aposentados/${centrus}/${mes}/${ano}`)
          .toPromise();
      }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/contracheque/service/contracheque.service.ts